<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.addEventListener("DOMContentLoaded", function() {
    const h2Elements = document.getElementsByClassName("instastory-title");
    
    for (const h2Element of h2Elements) {
      h2Element.addEventListener("click", function() {
        window.open("https://www.instagram.com/pimalubaby/", "_blank");
      });
    }
  });

